import Notifier from "./notifier";

class PostStream extends Notifier {
  constructor(response) {
    super();
    this.heartbeatTimer = undefined;
    this.stream(response);
  }

  resetHeartbeat(reader) {
    clearTimeout(this.heartbeatTimer);
    this.heartbeatTimer = setTimeout(() => {
      if (reader) {
        reader.cancel();
      }
    }, 20000);
  }

  async stream(response) {
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    try {
      this.resetHeartbeat(reader);
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          clearTimeout(this.heartbeatTimer);
          this.dispatch("done", value);
          break;
        }

        buffer += decoder.decode(value, { stream: true });

        // SSE messages are separated by double newlines
        const parts = buffer.split("\n\n");
        buffer = parts.pop(); // hold the last incomplete chunk

        for (const part of parts) {
          const eventLine = part.match(/^event: (.+)$/m)?.[1];
          const dataLine = part.match(/^data: (.+)$/m)?.[1];
          if (!dataLine) continue;

          const event = eventLine ?? "message";
          const data = dataLine ? JSON.parse(dataLine) : null;

          if (event === "done") {
            reader.cancel();
          } else if (event === "heartbeat") {
            this.resetHeartbeat(reader);
          } else {
            this.dispatch(event, data);
          }
        }
      }
    } catch (error) {
      this.dispatch("error", { message: "Error reading stream", error });
    }
  }
}

export default PostStream;
